import { render, staticRenderFns } from "./PlanSubscriptions.vue?vue&type=template&id=6b243300"
import script from "./PlanSubscriptions.vue?vue&type=script&lang=js"
export * from "./PlanSubscriptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports